import { AccountPermission } from 'modules/permissions/constants';
import { EMilliSeconds } from 'modules/common/constants/const';
import { isSSG } from 'modules/common/utils/isSSG';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useCheckAccountPermission } from 'modules/account/hooks/useCheckAccountPermission';

import { useFetchMyBundlesQuery } from '../actions/fetchMyBundles';

export const useMyBundles = () => {
  const { isLoggedIn } = useAuth();
  const { group } = useAccount();
  const { isEnterprise, loaded: accountStatusLoaded } = useAccountStatus();

  const hasBillingRoleAccess = useCheckAccountPermission({
    permission: AccountPermission.Billing,
  });

  const shouldFetch =
    !isSSG() &&
    isLoggedIn &&
    accountStatusLoaded &&
    hasBillingRoleAccess &&
    !isEnterprise;

  return useFetchMyBundlesQuery(
    { group },
    { skip: !shouldFetch, pollingInterval: 30 * EMilliSeconds.Second },
  );
};
